import axios from 'axios';
import config from 'config';
import { dataResponseInterceptor, unauthenticatedRequestInterceptor } from 'domains/api/interceptors';

export const schedulingAPIClient = axios.create({
  baseURL: config.get('schedulingApiURL'),
  headers: {
    'Content-type': 'application/json',
  },
});

schedulingAPIClient.interceptors.request.use(...unauthenticatedRequestInterceptor);

schedulingAPIClient.interceptors.response.use(...dataResponseInterceptor);
